/**
 * Actions Types
 */

export enum BiometriaTypes {
  SET_BASE64 = '@biometria/SET_BASE64',
  SET_ENCRYPTED = '@biometria/SET_ENCRYPTED',
  SET_ERROR = '@biometria/SET_ERROR',
  RESET_LIVENESS = '@biometria/RESET_LIVENESS',

  SET_LOADING_LIVENESS = '@biometria/SET_LOADING_LIVENESS',

  GET_LAST_LIVENESS = '@biometria/GET_LAST_LIVENESS',
  SET_LAST_LIVENESS = '@biometria/SET_LAST_LIVENESS',

  SET_BIOMETRIC_TOKEN = '@biometria/SET_BIOMETRIC_TOKEN',
  POST_BIOMETRICS_SAVE = '@biometria/POST_BIOMETRICS_SAVE',
  GET_VALIDATE_BIOMETRICS = '@biometria/GET_VALIDATE_BIOMETRICS',
  SET_LOADING_BIOMETRICS_VALIDATE = '@biometria/SET_LOADING_BIOMETRICS_VALIDATE',

  GET_BIOMETRIC_ACTIVE = '@biometria/GET_BIOMETRIC_ACTIVE',
  SET_BIOMETRIC_ACTIVE = '@biometria/SET_BIOMETRIC_ACTIVE',

  GET_USE_NEW_PROVIDERS = '@biometria/GET_USE_NEW_PROVIDERS',
  SET_USE_NEW_PROVIDERS = '@biometria/SET_USE_NEW_PROVIDERS',

  SEED_REQUEST = '@biometria/SEED_REQUEST',
  SEED_SUCCESS = '@biometria/SEED_SUCCESS',
  SEED_ERROR = '@biometria/SEED_ERROR',

  GENERATE_ID_UNICO_LINK_REQUEST = '@biometria/GENERATE_ID_UNICO_LINK_REQUEST',
  SET_LOADING_GENERATE_ID_UNICO_LINK = '@biometria/SET_LOADING_GENERATE_ID_UNICO_LINK',

  POST_VALIDATE_BIOMETRICS = '@biometria/POST_VALIDATE_BIOMETRICS',

  RESET = 'RESET',
}

export interface ILastLiveness {
  unicoId: string
  proposta: string
  status: string
  etapa: string
  dataCriacao: string
  score: number
}

export type BiometricActiveValue =
  | 'ID_CLOUD_WITH_DOCUMENTS'
  | 'ID_CLOUD_WITHOUT_DOCUMENTS'
  | 'SERASA_WITHOUT_DOCUMENTS'
  | 'SERASA_WITH_DOCUMENTS'

export const DEFAULT_BIOMETRIC_ACTIVE: BiometricActiveValue = 'SERASA_WITH_DOCUMENTS'

export const BIOMETRIC_ID_CLOUD_ACTIVE_VALUES: readonly BiometricActiveValue[] = [
  'ID_CLOUD_WITH_DOCUMENTS',
  'ID_CLOUD_WITHOUT_DOCUMENTS',
]

export interface GetBiometricActivePayload {
  onBiometricIdCloud?: () => void
}

export interface GetUseNewProvidersPayload {
  covenantId: string
  onUseNewProviders?: () => void
}

/**
 * State Type
 */

export interface BiometriaState {
  readonly base64: string | undefined
  readonly encrypted: string | undefined
  readonly error: false
  readonly retryLiveness: false
  readonly loadingLiveness: false
  readonly unicoId: string
  readonly lastLiveness: ILastLiveness
  readonly biometricToken: string
  readonly loadingBiometricsValidate: boolean
  readonly biometricActive: BiometricActiveValue
  readonly loadingGenerateIdUnicoLink: boolean
  readonly seed: string
  readonly seedError: boolean
  readonly seedLoading: boolean
}

export interface CallbackLastLiveness {
  callback: (lastLiveness: ILastLiveness) => void
}

export interface CallbackBiometriaDados {
  callback: (biometricToken: string) => void
}

export interface CallbackBiometriaValidate {
  callback: (isValid: boolean) => void
}

export interface GenerateIdUnicoLinkRequestPayload {
  callback: (biometricLink: string) => void
}

export interface CallbackPostValidateBiometrics {
  callback: () => void
}
